import { createApp } from "vue";
import PrimeVue from "primevue/config";
import VueGtag from "vue-gtag";
import MetaPixel from "../plugins/MetaPixel";
import router from "./router";
import App from "./App.vue";
import { NavBar, Footer } from "@maxxpm/vue-components";
import config from "./config/index";

// import "primevue/resources/themes/lara-light-teal/theme.css"; //theme
import "../src/assets/themes/mytheme/theme.scss"; //theme
import "primevue/resources/primevue.min.css"; //core css
import "primeflex/primeflex.css"; //flex
import "primeicons/primeicons.css"; //icons

const app = createApp(App);

app.use(PrimeVue);

app.component("nav-bar", NavBar);
app.component("app-footer", Footer);
app.provide("$maxxpm", {
  config,
});

if (config.gtagId) {
  app.use(VueGtag, {
    appName: `${config.communityName} Website`,
    pageTrackerScreenviewEnabled: true,
    config: {
      id: config.gtagId,
    },
    router,
  });
}

// Initialize Meta Pixel if pixel ID is configured and not already initialized
if (config.metaPixelId && !window.__META_PIXEL_INITIALIZED__) {
  // Check if Facebook Pixel script already exists
  const existingScript = document.querySelector('script[src*="connect.facebook.net"]');
  // Check if fbq function already exists
  const existingFbq = typeof window.fbq !== 'undefined';
  
  // Check for any existing Facebook-related scripts
  const allScripts = document.querySelectorAll('script[src]');
  const facebookScripts = Array.from(allScripts).filter(script => 
    script.src.includes('facebook') || 
    script.src.includes('fbq') || 
    script.src.includes('fbevents')
  );
  
  // Check if there's any existing Meta Pixel activity
  const hasExistingMetaPixel = existingScript || existingFbq || facebookScripts.length > 0;
  
  // Only initialize if there are absolutely no conflicts
  if (!hasExistingMetaPixel) {
    window.__META_PIXEL_INITIALIZED__ = true;
    app.use(MetaPixel, {
      pixelId: config.metaPixelId,
      autoPageView: true,
      debug: process.env.NODE_ENV === 'development'
    });
  } else {
    console.warn('Meta Pixel already exists on page, skipping plugin installation');
  }
}

app.use(router).mount("#app");

// function scale(color, adjustment) {
//   color = color.replace("#", "");
//   if (color.length === 6) {
//     const decimalColor = parseInt(color, 16);

//     let r = (decimalColor >> 16) + adjustment;
//     r > 255 && (r = 255);
//     r < 0 && (r = 0);

//     let g = (decimalColor & 0x0000ff) + adjustment;
//     g > 255 && (g = 255);
//     g < 0 && (g = 0);

//     let b = ((decimalColor >> 8) & 0x00ff) + adjustment;
//     b > 255 && (g = 255);
//     b < 0 && (g = 0);

//     return `#${(g | (b << 8) | (r << 16)).toString(16)}`;
//   }
// }

// function setCssVar(variable, value) {
//   document.documentElement.style.setProperty(variable, value);
// }
